import React, { useEffect, useState } from "react";
import TermsConditionsData from "../../../../JsonFiles/InstituteTermsAndConditions.json"
 
const renderBoldText = (text) => {
    return text.split(/(\(.*?\)|".*?")/g).map((part, index) => {
      if (part.startsWith("(") || part.startsWith("\"")) {
        return <strong key={index}>{part}</strong>;
      }
      return part;
    });
  };

  const renderEmailBoldText = (text) => {
    return text.replace(/[\(\)"]/g, '').split(/(\b\w+@\w+\.\w+\b|\+\d{1,3} \d{3} \d{3} \d{4})/g).map((part, index) => {
      if (/\b\w+@\w+\.\w+\b|\+\d{1,3} \d{3} \d{3} \d{4}/.test(part)) {
        return <strong key={index}>{part}</strong>;
      }
      return part;
    });
};

const InstituteTermAndConditions = ({setOpenSignupScreen, InstituteData, setInstituteData}) => {
    const [checkedItems, setCheckedItems] = useState({});
    const [showError, setShowError] = useState(false);
    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    const handleCheckboxChange = (id) => {
      setCheckedItems((prev) => ({
        ...prev,
        [id]: !prev[id], // Toggle checked state
      }));
    };

    const handleSignatureChange = (signature) => {
        setInstituteData((prevData) => ({
            ...prevData,
            ownersSignature: signature, // Update the signature field
        }));
    };    


    const allChecked = TermsConditionsData.content.every((item) => checkedItems[item.id]);
    const isButtonDisabled = !allChecked || !InstituteData.ownersSignature.trim();

    const handleAgreeClick = () => {
        if (!allChecked || !InstituteData.ownersSignature.trim()) {
            setShowError(true);
        } else {
            setOpenSignupScreen("ViewInstituteRegisterationData");
        }
    };
return(
    <div className="w-full py-[20px] pl-[30px] pr-[20px] lg:pl-[50px] lg:pr-[50px] flex flex-col gap-[10px]">
            <p className="text-[32px] font-bold text-center">{TermsConditionsData.title}</p>
            <div className="w-full flex justify-center items-center">
            <p className="text-[22px] text-center w-[750px]">{TermsConditionsData.subtitle}</p>
            </div>
            <p className="text-[22px] font-semibold mt-[20px]">Effective Date: {TermsConditionsData.effectiveDate}</p>
            <p className="text-[22px] leading-[26px] mt-[10px]">{renderBoldText(TermsConditionsData.TopParagraph)}</p>
            
              {/* Terms and Conditions List with Scrollable Div */}
            <div className="w-full bg-[#FAFAFA] p-[5px] lg:p-[20px] mt-[20px] h-[600px] overflow-y-auto rounded-lg shadow-md">
            {TermsConditionsData.content.map((item) => (
                <div
                key={item.id}
                className={`p-4 mb-2 rounded-md flex items-start gap-2 transition-colors duration-200 text-[18px] lg:text-[20px]`}
                >
                {/* Checkbox */}
                <input
                    type="checkbox"
                    checked={checkedItems[item.id] || false}
                    onChange={() => handleCheckboxChange(item.id)}
                    className={`w-[25px] h-[25px] cursor-pointer pt-[10px] ${
                        checkedItems[item.id] ? "accent-[#625BA8]" : "accent-gray-400"
                        }`}
                />
                {/* Text Content */}
                <div>
                    <p>
                    <strong>{item.title}</strong> {item.text}
                    </p>
                </div>
                </div>
            ))}
            </div>

            <p className="text-[20px] mt-[25px]">{renderEmailBoldText(TermsConditionsData.contactInfo)}</p>
            <p className="text-[20px] mt-[15px]">{TermsConditionsData.agreement}</p>

            <div className="w-full flex flex-col gap-[5px] mt-[15px]">
            <p className="text-[20px]">Owner Signature</p>
            <input
                type="text"
                id="OwnerSignature"
                name="OwnerSignature"
                placeholder="Signature (Name)"
                value={InstituteData.ownersSignature}
                onChange={(e) => handleSignatureChange(e.target.value)}
                className={`w-full rounded-md py-[10px] px-[10px] ${Border} shadow-md`}
            />
            </div>

            {/* Error for Checkboxes */}
            {showError && !allChecked && (
                <p className="text-[#FF0000] text-[12px]">Please check all terms and conditions.</p>
            )}
            {showError && !InstituteData.ownersSignature.trim() && (
                    <p className="text-[#FF0000] text-[12px]">Please provide your signature.</p>
                )}
            <div className="w-full flex justify-end gap-[20px] mt-[20px]">
            <button
                className="cursor-pointer rounded-[8px] py-2 text-[16px] text-[#625BA8] xl:py-2 xl:text-[18px] 2xl:text-base"
                onClick={() => {
                                    setOpenSignupScreen("PackageSelection")
                            }} 
            >
                Back
            </button>
            <button
                className={`w-[130px] cursor-pointer rounded-[8px] border-none py-3 text-[16px] text-white xl:py-2 xl:text-[18px] 2xl:text-base bg-[#625BA8]`}
                onClick={handleAgreeClick}
            >
                I Agree
            </button>
            </div>
    </div>
)
}

export default InstituteTermAndConditions;
